export const GTM_EVENT_NAMES = {
  PROVISO_STATUS: 'proviso_status',
  PROVISO_IFRAME_NAVIGATION: 'proviso_iframe_navigation',
  INCOME_COMPLETE: 'income_complete',
};
